import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link, useNavigate, useParams } from 'react-router-dom'
import ForgotPassword from './ForgotPassword'
import Login from './Login'
import { access } from 'fs'
import Spinner from '../ui-elements/Spinner'

type Props = {
    showForm: string
}


function NotLoggedIn({
    showForm = 'login'
}: Props) {

    const {
        idToken,
        accessToken
    } = useContext(GlobalContext)

    const haveGotTokens = idToken && accessToken

    return <div className={`bg-brandblue text-white flex w-full flex-col min-h-screen items-center justify-center text-center gap-4 p-4`}>

        <div className={`w-full max-w-sm flex flex-col gap-6 items-center justify-center`}>

            <img
                src={`/logos/logo-white-no-strapline.svg`}
                alt={'ChecQR logo'}
                className={`w-72`}
            />


            {haveGotTokens && <Spinner size='large'>Logging in...</Spinner>}


            {!haveGotTokens && showForm === 'forgotPassword' && <ForgotPassword />}
            {!haveGotTokens && showForm === 'login' && <Login />} 

        </div>
    </div >
}
export default NotLoggedIn